/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ContinueInputs */

const en_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const fr_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitermachen`)
};

const it_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuare`)
};

const ru_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжать`)
};

const es_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const zh_cn2_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const ja_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続く`)
};

const hi_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जारी रखना`)
};

const pt_pt2_common_continue = /** @type {(inputs: Common_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Common_ContinueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_continue = /** @type {((inputs?: Common_ContinueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ContinueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_continue(inputs)
	if (locale === "de") return de_common_continue(inputs)
	if (locale === "it") return it_common_continue(inputs)
	if (locale === "ru") return ru_common_continue(inputs)
	if (locale === "es") return es_common_continue(inputs)
	if (locale === "zh-CN") return zh_cn2_common_continue(inputs)
	if (locale === "ja") return ja_common_continue(inputs)
	if (locale === "hi") return hi_common_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_common_continue(inputs)
	return en_common_continue(inputs)
});